import React from 'react'
import PropTypes from 'prop-types'
import RankedList from '@/component/Primitive/RankedList'

const MostPopularOrViewedWidget = ({ articles, itemType, displayCategory }) => {
  if (!articles || !articles.results.length) return null

  const formattedArticles = articles.results?.map((article) => ({
    id: article._id,
    content: article.headline,
    href: article.fullUrlPath,
    category: displayCategory && article.category
  }))

  return (
    <RankedList
      titlePrimary="#Most"
      titleSecondary={itemType === 'popular' ? 'Popular' : 'Viewed'}
      listData={formattedArticles}
    />
  )
}

MostPopularOrViewedWidget.propTypes = {
  articles: PropTypes.object,
  itemType: PropTypes.string,
  displayCategory: PropTypes.bool
}

export default MostPopularOrViewedWidget
